import { Box } from '@apia/theme';
import { CollectorField } from '../CollectorField';
import { ReactNode } from 'react';

export class CollectorLabel extends CollectorField {
  private static maxId = 0;

  type = 'label';

  constructor(
    label: ReactNode,
    private kind:
      | 'h1'
      | 'h2'
      | 'h3'
      | 'h4'
      | 'h5'
      | 'h6'
      | 'p'
      | 'label' = 'label',
  ) {
    super(`label${CollectorLabel.maxId++}`, label);
  }

  Component = () => {
    if (this.kind === 'label') return <Box as={this.kind}>{this.label}</Box>;

    return <Box as={this.kind}>{this.label}</Box>;
  };
}
